export const visit = (vm, at) => {
at({ "en": { "reporting-enablement": { "reportEditors": { "reset": { "label": "Reset filters", "tooltip": { "editors": "Reset editors" } } } } } });
};